module.exports = {"370126001":"许商街道","370126101":"殷巷镇","370126102":"怀仁镇","370126104":"龙桑寺镇","370126105":"郑路镇","370126106":"贾庄镇","370126107":"玉皇庙镇","370126108":"白桥镇","370126109":"孙集镇","370126110":"韩庙镇","370126111":"沙河镇","370126112":"张坊镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370126.json
// module id = 1361
// module chunks = 0